import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Layout from '../layout'

let isLanguage = window.sessionStorage.getItem('language') ? window.sessionStorage.getItem('language') : 'English'
Vue.use(VueRouter)
export const constantRoutes = [
    {
        path: '/',
        redirect: '/controlPanel',
        component: Layout,
        children: [
            {
                path: 'controlPanel',
                name: 'controlPanel',
                component: () => import(/* webpackChunkName:"controlPanel"*/'@/views/controlPanel'),
                meta: {title: isLanguage === 'English' ? 'Control panel' : '控制面板', icon: 'Dashboard1'}
            }
        ]
    },
    {
        path: '/multiWallet',
        redirect: '/multiWallet/list',
        component: Layout,
        children: [
            {
                path: 'list',
                name: 'multiWallet',
                component: () => import(/* webpackChunkName:"multiWalletList"*/'@/views/multiWallet/list'),
                meta: {title: isLanguage === 'English' ? 'Multi-currency' : '多币种钱包', icon: 'wallet'},
                noShowingChildren: true,
                children: [
                    {
                        path: 'walletDetail',
                        name: 'walletDetail',
                        component: () => import('@/views/multiWallet/detail'),
                        meta: {
                            title: isLanguage === 'English' ? 'Wallet Details' : '钱包详情',
                            noCache: true,
                            activeMenu: '/multiWallet/list'
                        }
                    },
                    {
                        path: 'recharge',
                        name: 'recharge',
                        component: () => import('@/views/recharge'),
                        meta: {
                            title: isLanguage === 'English' ? 'Top up' : '充值',
                            noCache: true,
                            activeMenu: '/multiWallet/list'
                        },
                        hidden: true
                    },
                ]
            },
        ]
    },
    {
        path: '/virtualCard',
        redirect: '/virtualCard/list',
        component: Layout,
        children: [
            {
                path: 'list',
                name: 'virtualCard',
                component: () => import('@/views/virtualCard/list'),
                meta: {title: isLanguage === 'English' ? 'Virtual card' : '虚拟信用卡管理', icon: 'creditcard'},
                noShowingChildren: true,
                children: [
                    {
                        path: 'apply',
                        name: 'applyVirtualCard',
                        component: () => import('@/views/virtualCard/apply'),
                        meta: {
                            title: isLanguage === 'English' ? 'Apply for Virtual Credit Card' : '虚拟信用卡申请',
                            noCache: true,
                            activeMenu: '/virtualCard/list'
                        },
                        hidden: true
                    },
                    {
                        path: 'details',
                        name: 'virtualCardDetail',
                        component: () => import('@/views/virtualCard/details'),
                        meta: {
                            title: isLanguage === 'English' ? 'Virtual credit card details' : '虚拟信用卡详情',
                            noCache: true,
                            activeMenu: '/virtualCard/list'
                        },
                        hidden: true
                    }
                ]
            }
        ]
    },
    {
        path: '/cardTransaction',
        redirect: '/cardTransaction/list',
        component: Layout,
        children: [
            {
                path: 'list',
                name: 'cardTransaction',
                component: () => import('@/views/cardTransaction/list'),
                meta: {title: isLanguage === 'English' ? 'Card Transaction' : '信用卡交易记录', icon: 'form'},
                noShowingChildren: true,
            }
        ]
    },
    {
        path: '/supplierManage',
        redirect: '/supplierManage/list',
        component: Layout,
        children: [
            {
                path: 'list',
                name: 'supplierManage',
                component: () => import('@/views/supplierManage/list'),
                meta: {title: isLanguage === 'English' ? 'Supplier' : '供应商管理', icon: 'users'},
                noShowingChildren: true,
                children: [
                    {
                        path: 'addSupplier',
                        name: 'addSupplier',
                        component: () => import('@/views/supplierManage/addSupplier'),
                        meta: {
                            title: isLanguage === 'English' ? 'Add supplier' : '添加供应商',
                            noCache: true,
                            activeMenu: '/supplierManage/list'
                        },
                        hidden: true
                    }
                ]
            }
        ]
    },
    {
        path: '/systemSetting',
        component: Layout,
        children: [
            {
                path: '',
                name: 'systemSetting',
                component: () => import('@/views/systemSetting/index'),
                meta: {
                    title: isLanguage === 'English' ? 'System settings' : '系统设置',
                    icon: 'setting',
                    activeMenu: '/systemSetting'
                }
            }
        ]
    },
    {
        path: '/enterpriseCertification',
        component: Layout,
        children: [
            {
                path: '',
                name: 'enterpriseCertification',
                component: () => import('@/views/enterpriseCertification'),
            }
        ]
    },
    {
        path: '/supplier',
        name: 'supplier',
        component: () => import('@/views/supplier')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/register')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login')
    },
    {
        path: '/login/forgot',
        name: 'forgot',
        component: () => import('@/views/login/forgot')
    },
    {
        path: '/login/reset',
        name: 'reset',
        component: () => import('@/views/login/reset')
    },
    {
        path: '/terms',
        name: 'terms',
        component: () => import('@/views/terms')
    },
    {
        path: '/404',
        component: Layout,
        children: [
            {
                path: '',
                component: () => import('@/views/404'),
                hidden: true
            }
        ]
    },

    // 404 page must be placed at the end !!!
    {path: '*', redirect: '/404', hidden: true}
]
const createRouter = () => new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
